// extracted by mini-css-extract-plugin
module.exports =  {"columnsSelector":"columnsSelector_K3h9yJFm","subTitle":"subTitle_o0dFQVdp","calculation":"calculation_nm2susVw","subList":"subList_ldrFqxeY"};